module.exports = __webpack_public_path__ + "img/Badges.9a13588b.svg";